import React from "react";

// Pure-CSS seamless marquee. Children are duplicated for a continuous loop.
export const Marquee = ({ children, className = "", speed = 40 }) => (
  <div className={`mask-fade-x overflow-hidden ${className}`}>
    <div className="flex w-max animate-marquee-track" style={{ animationDuration: `${speed}s` }}>
      <div className="flex shrink-0 items-center">{children}</div>
      <div className="flex shrink-0 items-center" aria-hidden>{children}</div>
    </div>
  </div>
);
